/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const EnumTimelineContentType = {
    Memo: 'memo',
    Audit: 'audit',
    Action: 'action',
    UserOperation: 'user_operation'
};
export function EnumTimelineContentTypeFromJSON(json) {
    return EnumTimelineContentTypeFromJSONTyped(json, false);
}
export function EnumTimelineContentTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function EnumTimelineContentTypeToJSON(value) {
    return value;
}
